var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color",
      value: _vm.type === 'star' ? 'yellow' : 'red',
      expression: "type === 'star' ? 'yellow' : 'red'"
    }],
    attrs: {
      "name": "basic_".concat(_vm.type, "-filled"),
      "size": 16
    }
  }), _c('span', {
    directives: [{
      name: "m-l",
      rawName: "v-m-l",
      value: 5,
      expression: "5"
    }],
    domProps: {
      "textContent": _vm._s(_vm.displayGrade)
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }